// Strings for the registrations page, the entry editor and the export dialog.
import { registerMessages } from '../i18n.svelte';

registerMessages({
  nl: {
    // Page
    'entries.subtitle': '{count} registraties · {period}',
    'entries.subtitle.one': '1 registratie · {period}',
    'entries.new': 'Nieuwe registratie',
    'entries.search_placeholder': 'Zoek op omschrijving, klant, factuur…',
    'entries.filters': 'Filters',
    'entries.type': 'Type',
    'entries.billable_only': 'Alleen factureerbaar',
    'entries.non_billable_only': 'Alleen niet factureerbaar',
    'entries.archived': 'Gearchiveerd',
    'entries.activity_global': 'Alle klanten',
    'entries.no_results': 'Geen resultaten',
    'entries.view': 'Weergave',
    'entries.view_list': 'Lijst',
    'entries.view_day': 'Per dag',
    'entries.view_activity': 'Per activiteit',
    'entries.columns': 'Kolommen',
    'entries.col_date': 'Datum',
    'entries.col_time': 'Tijd',
    'entries.col_client': 'Klant',
    'entries.col_activity': 'Activiteit',
    'entries.col_description': 'Omschrijving',
    'entries.col_duration': 'Uren',
    'entries.col_rate': 'Tarief',
    'entries.col_amount': 'Bedrag',
    'entries.col_status': 'Status',
    'entries.sort': 'Sorteren',
    'entries.sort_date': 'Datum',
    'entries.sort_client': 'Klant',
    'entries.sort_activity': 'Activiteit',
    'entries.sort_description': 'Omschrijving',
    'entries.sort_hours': 'Uren',
    'entries.sort_rate': 'Tarief',
    'entries.sort_amount': 'Bedrag',
    'entries.sort_status': 'Status',
    'entries.sorted_by': 'Gesorteerd op {sort}',
    'entries.ascending': 'Oplopend',
    'entries.descending': 'Aflopend',
    'entries.total_count': 'Registraties',
    'entries.total_hours': 'Uren',
    'entries.total_revenue': 'Omzet',
    'entries.total_outstanding': 'Openstaand',
    'entries.billable_hours_short': '{hours} factureerbaar',
    'entries.avg_rate': 'gem. {rate}/u',
    'entries.avg_rate_short': 'Gem. tarief',
    'entries.paid_amount': '{amount} betaald',
    'entries.n_entries': '{count} registraties',
    'entries.n_entries.one': '1 registratie',
    'entries.showing': '{shown} van {total} getoond',
    'entries.show_more_n': '{count} meer tonen',
    'entries.show_all': 'Alles tonen',
    'entries.show_results': '{count} resultaten tonen',
    'entries.show_results.one': '1 resultaat tonen',
    'entries.show_all_time': 'Alles tonen',
    'entries.empty_title': 'Nog geen registraties',
    'entries.empty_desc': 'Registreer je eerste uren handmatig, of start de timer en sla hem op als je klaar bent.',
    'entries.empty_cta': 'Eerste registratie toevoegen',
    'entries.empty_timer': 'Timer starten',
    'entries.no_match_title': 'Niets gevonden',
    'entries.no_match_desc': 'Geen registraties komen overeen met je zoekopdracht of filters.',
    'entries.no_period_title': 'Geen registraties in deze periode',
    'entries.no_period_desc': 'Er is niets geregistreerd in {period}.',
    'entries.rounded_tip': 'Afgerond van {original}',
    'entries.pause_tip': '{min} minuten pauze',

    // Selection & bulk
    'entries.select_entry': 'Registratie selecteren',
    'entries.select_visible': 'Alles op deze pagina selecteren',
    'entries.visible_selected': 'Alle {count} getoonde registraties zijn geselecteerd.',
    'entries.select_all_n': 'Selecteer alle {count} registraties',
    'entries.outstanding_short': '{amount} open',
    'entries.mark_paid': 'Markeer betaald',
    'entries.mark_open': 'Markeer als openstaand',
    'entries.mark_partial': 'Deelbetaling registreren…',
    'entries.mark_non_billable': 'Markeer als niet factureerbaar',
    'entries.marked': '{count} registraties gemarkeerd als {status}',
    'entries.marked.one': '1 registratie gemarkeerd als {status}',
    'entries.change_client': 'Klant wijzigen…',
    'entries.change_activity': 'Activiteit wijzigen…',
    'entries.toggle_billable': 'Factureerbaar omdraaien',
    'entries.billable_toggled': 'Factureerbaar omgedraaid voor {count} registraties',
    'entries.billable_toggled.one': 'Factureerbaar omgedraaid voor 1 registratie',
    'entries.export_selection': 'Selectie exporteren…',
    'entries.export_selection_title': 'Selectie',
    'entries.delete_many_title': '{count} registraties verwijderen?',
    'entries.delete_many_title.one': '1 registratie verwijderen?',
    'entries.delete_many_message': 'Samen {hours} uur en {amount}.',
    'entries.deleted_many': '{count} registraties verwijderd',
    'entries.deleted_many.one': '1 registratie verwijderd',
    'entries.bulk_client_title': 'Klant wijzigen',
    'entries.bulk_activity_title': 'Activiteit wijzigen',
    'entries.bulk_for': 'Voor {count} geselecteerde registraties',
    'entries.bulk_for.one': 'Voor 1 geselecteerde registratie',
    'entries.bulk_client_hint': 'Het tarief en de bedragen blijven zoals ze zijn.',
    'entries.client_changed': 'Klant gewijzigd voor {count} registraties',
    'entries.client_changed.one': 'Klant gewijzigd voor 1 registratie',
    'entries.activity_changed': 'Activiteit gewijzigd voor {count} registraties',
    'entries.activity_changed.one': 'Activiteit gewijzigd voor 1 registratie',

    // Activity groups & budget
    'entries.select_group': 'Alles in deze groep selecteren',
    'entries.mark_group_paid': 'Hele groep betaald',
    'entries.mark_group_open': 'Hele groep openstaand',
    'entries.mark_group_non_billable': 'Hele groep niet factureerbaar',
    'entries.set_budget': 'Budget instellen…',
    'entries.edit_budget': 'Budget wijzigen…',
    'entries.budget': 'Budget (offerteprijs)',
    'entries.budget_title': 'Budget',
    'entries.budget_hint': 'Laat leeg om het budget te verwijderen.',
    'entries.budget_saved': 'Budget opgeslagen',
    'entries.budget_vs': '{actual} van {budget}',
    'entries.budget_left': 'nog {amount} over',
    'entries.budget_over': '{amount} over budget',

    // Row actions
    'entries.continue_timer': 'Verder in timer',
    'entries.timer_started': 'Timer gestart',
    'entries.replace_timer_title': 'Huidige timer vervangen?',
    'entries.replace_timer_message': 'Er loopt al een timer. Als je doorgaat, start een nieuwe timer met deze klant, activiteit en omschrijving.',
    'entries.register_payment': 'Betaling registreren…',
    'entries.delete_one_title': 'Registratie verwijderen?',
    'entries.delete_one_message': 'Je kunt dit direct daarna nog ongedaan maken.',
    'entries.deleted_one': 'Registratie verwijderd',
    'entries.restored': 'Teruggezet',

    // Editor
    'entries.new_title': 'Nieuwe registratie',
    'entries.edit_title': 'Registratie bewerken',
    'entries.duplicate_title': 'Registratie dupliceren',
    'entries.duplicate_of': 'Kopie van {date}',
    'entries.section_time': 'Tijd',
    'entries.section_what': 'Werk',
    'entries.section_money': 'Financieel',
    'entries.section_payment': 'Betaling',
    'entries.now': 'Nu',
    'entries.min': 'min',
    'entries.rounded_from': 'Afgerond van {original} ({diff} min)',
    'entries.rounding_rule': 'Afronding: {mode} op {inc} min',
    'entries.rounding_applied': 'Afronding toegepast: {mode}, {inc} min',
    'entries.rounding_none': 'geen',
    'entries.rounding_nearest': 'dichtstbijzijnde',
    'entries.rounding_up': 'omhoog',
    'entries.rounding_down': 'omlaag',
    'entries.rounding_threshold': 'drempel',
    'entries.overnight_split': 'Loopt door na middernacht: wordt opgeslagen als twee registraties (tot 23:59 en vanaf 00:00 op {date}).',
    'entries.client_placeholder': 'Kies of typ een klant',
    'entries.activity_placeholder': 'Kies of typ een activiteit',
    'entries.description_placeholder': 'Waar heb je aan gewerkt?',
    'entries.create_client': '"{name}" toevoegen als nieuwe klant',
    'entries.create_activity': '"{name}" toevoegen als activiteit',
    'entries.client_created': 'Klant {name} toegevoegd',
    'entries.no_activities': 'Nog geen activiteiten: typ een naam om er een toe te voegen',
    'entries.billable_hint': 'Telt mee voor omzet en openstaande bedragen.',
    'entries.amount_paid': 'Betaald bedrag',
    'entries.outstanding_label': 'Openstaand',
    'entries.mark_fully_paid': 'Volledig betaald',
    'entries.invoice_reference': 'Factuurnummer',
    'entries.invoice_hint': 'Maximaal 50 tekens.',
    'entries.add': 'Toevoegen',
    'entries.created': 'Registratie toegevoegd',
    'entries.created_split': 'Opgeslagen als twee registraties',
    'entries.updated': 'Registratie bijgewerkt',
    'entries.discard_title': 'Wijzigingen weggooien?',
    'entries.discard_message': 'Je hebt wijzigingen die nog niet zijn opgeslagen.',
    'entries.discard': 'Weggooien',
    'entries.err_date': 'Kies een datum',
    'entries.err_time': 'Vul een tijd in',
    'entries.err_zero': 'Start en eind zijn gelijk',
    'entries.err_end_after_start': 'De eindtijd moet na de starttijd liggen',
    'entries.err_pause': 'Pauze kan niet negatief zijn',
    'entries.err_pause_long': 'Pauze is langer dan de gewerkte tijd',
    'entries.err_client': 'Kies een klant',
    'entries.err_rate': 'Tarief kan niet negatief zijn',
    'entries.err_paid_max': 'Mag niet meer zijn dan {max}',
    'entries.err_amount': 'Vul een geldig bedrag in',
    'entries.err_invoice': 'Maximaal 50 tekens',

    // Payment modals
    'entries.payment_title': 'Betaling registreren',
    'entries.payment_mode': 'Manier',
    'entries.payment_add': 'Bedrag toevoegen',
    'entries.payment_replace': 'Totaal vervangen',
    'entries.payment_amount_add': 'Ontvangen bedrag',
    'entries.payment_amount_total': 'Totaal betaald',
    'entries.payment_new_total': 'Nieuw totaal betaald: {amount}',
    'entries.status_auto': 'Automatisch op basis van het bedrag',
    'entries.payment_save': 'Betaling opslaan',
    'entries.payment_saved': 'Betaling opgeslagen',
    'entries.partial_title': 'Deelbetaling',
    'entries.partial_desc': '{count} registraties, samen {amount} openstaand',
    'entries.partial_desc.one': '1 registratie, {amount} openstaand',
    'entries.partial_mode': 'Verdeling',
    'entries.partial_proportional': 'Naar verhouding',
    'entries.partial_sequential': 'Oudste eerst',
    'entries.partial_proportional_hint': 'Het bedrag wordt verdeeld naar het openstaande bedrag per registratie.',
    'entries.partial_sequential_hint': 'De oudste registraties worden eerst volledig betaald.',
    'entries.payment_applied': '{amount} verdeeld over {count} registraties',
    'entries.payment_applied.one': '{amount} geboekt op 1 registratie',

    // Export
    'export.title': 'Exporteren',
    'export.selection_desc': '{count} geselecteerde registraties',
    'export.selection_desc.one': '1 geselecteerde registratie',
    'export.what': 'Wat',
    'export.format': 'Formaat',
    'export.columns': 'Kolommen',
    'export.filter': 'Periode en klanten',
    'export.type_detailed': 'Gedetailleerd',
    'export.type_detailed_hint': 'Elke registratie op een regel',
    'export.type_per_client': 'Per klant',
    'export.type_per_client_hint': 'Uren en bedragen per klant',
    'export.type_per_activity': 'Per activiteit',
    'export.type_per_activity_hint': 'Met budget per activiteit',
    'export.type_per_day': 'Per dag',
    'export.type_per_day_hint': 'Dagtotalen, handig voor je urenstaat',
    'export.opt_description': 'Omschrijving',
    'export.opt_financial': 'Financiële kolommen',
    'export.opt_times': 'Start, eind en pauze',
    'export.from': 'Van',
    'export.to': 'Tot en met',
    'export.preset_month': 'Deze maand',
    'export.preset_last_month': 'Vorige maand',
    'export.preset_year': 'Dit jaar',
    'export.all_available': 'Alles',
    'export.run': 'Exporteer {format}',
    'export.done': '{count} registraties geëxporteerd',
    'export.done.one': '1 registratie geëxporteerd',
    'export.nothing': 'Geen registraties om te exporteren',
    'export.summary_count': '{count} registraties',
    'export.summary_count.one': '1 registratie',
    'export.hours_unit': 'uur',
    'export.default_title': 'Urenoverzicht',
    'export.filename_base': 'registraties',
    'export.sheet_entries': 'Registraties',
    'export.col_pause': 'Pauze (min)',
    'export.col_paid': 'Betaald',
    'export.col_invoice': 'Factuur',
    'export.col_count': 'Aantal',
    'export.col_revenue': 'Omzet',
    'export.col_outstanding': 'Openstaand',
    'export.col_budget': 'Budget',
    'export.generated_on': 'Gemaakt op {date} met Timepeak',
    'export.page_of': 'Pagina {page} van {total}'
  },
  en: {
    'entries.subtitle': '{count} entries · {period}',
    'entries.subtitle.one': '1 entry · {period}',
    'entries.new': 'New entry',
    'entries.search_placeholder': 'Search description, client, invoice…',
    'entries.filters': 'Filters',
    'entries.type': 'Type',
    'entries.billable_only': 'Billable only',
    'entries.non_billable_only': 'Non-billable only',
    'entries.archived': 'Archived',
    'entries.activity_global': 'All clients',
    'entries.no_results': 'No results',
    'entries.view': 'View',
    'entries.view_list': 'List',
    'entries.view_day': 'By day',
    'entries.view_activity': 'By activity',
    'entries.columns': 'Columns',
    'entries.col_date': 'Date',
    'entries.col_time': 'Time',
    'entries.col_client': 'Client',
    'entries.col_activity': 'Activity',
    'entries.col_description': 'Description',
    'entries.col_duration': 'Hours',
    'entries.col_rate': 'Rate',
    'entries.col_amount': 'Amount',
    'entries.col_status': 'Status',
    'entries.sort': 'Sort',
    'entries.sort_date': 'Date',
    'entries.sort_client': 'Client',
    'entries.sort_activity': 'Activity',
    'entries.sort_description': 'Description',
    'entries.sort_hours': 'Hours',
    'entries.sort_rate': 'Rate',
    'entries.sort_amount': 'Amount',
    'entries.sort_status': 'Status',
    'entries.sorted_by': 'Sorted by {sort}',
    'entries.ascending': 'Ascending',
    'entries.descending': 'Descending',
    'entries.total_count': 'Entries',
    'entries.total_hours': 'Hours',
    'entries.total_revenue': 'Revenue',
    'entries.total_outstanding': 'Outstanding',
    'entries.billable_hours_short': '{hours} billable',
    'entries.avg_rate': 'avg. {rate}/h',
    'entries.avg_rate_short': 'Avg. rate',
    'entries.paid_amount': '{amount} paid',
    'entries.n_entries': '{count} entries',
    'entries.n_entries.one': '1 entry',
    'entries.showing': 'Showing {shown} of {total}',
    'entries.show_more_n': 'Show {count} more',
    'entries.show_all': 'Show all',
    'entries.show_results': 'Show {count} results',
    'entries.show_results.one': 'Show 1 result',
    'entries.show_all_time': 'Show all time',
    'entries.empty_title': 'No entries yet',
    'entries.empty_desc': 'Log your first hours by hand, or start the timer and save it when you are done.',
    'entries.empty_cta': 'Add your first entry',
    'entries.empty_timer': 'Start the timer',
    'entries.no_match_title': 'Nothing found',
    'entries.no_match_desc': 'No entries match your search or filters.',
    'entries.no_period_title': 'No entries in this period',
    'entries.no_period_desc': 'Nothing was logged in {period}.',
    'entries.rounded_tip': 'Rounded from {original}',
    'entries.pause_tip': '{min} minutes break',

    'entries.select_entry': 'Select entry',
    'entries.select_visible': 'Select everything on this page',
    'entries.visible_selected': 'All {count} entries shown are selected.',
    'entries.select_all_n': 'Select all {count} entries',
    'entries.outstanding_short': '{amount} outstanding',
    'entries.mark_paid': 'Mark paid',
    'entries.mark_open': 'Mark as outstanding',
    'entries.mark_partial': 'Record partial payment…',
    'entries.mark_non_billable': 'Mark as non-billable',
    'entries.marked': '{count} entries marked as {status}',
    'entries.marked.one': '1 entry marked as {status}',
    'entries.change_client': 'Change client…',
    'entries.change_activity': 'Change activity…',
    'entries.toggle_billable': 'Flip billable',
    'entries.billable_toggled': 'Billable flipped for {count} entries',
    'entries.billable_toggled.one': 'Billable flipped for 1 entry',
    'entries.export_selection': 'Export selection…',
    'entries.export_selection_title': 'Selection',
    'entries.delete_many_title': 'Delete {count} entries?',
    'entries.delete_many_title.one': 'Delete 1 entry?',
    'entries.delete_many_message': 'Together {hours} hours and {amount}.',
    'entries.deleted_many': '{count} entries deleted',
    'entries.deleted_many.one': '1 entry deleted',
    'entries.bulk_client_title': 'Change client',
    'entries.bulk_activity_title': 'Change activity',
    'entries.bulk_for': 'For {count} selected entries',
    'entries.bulk_for.one': 'For 1 selected entry',
    'entries.bulk_client_hint': 'Rates and amounts stay as they are.',
    'entries.client_changed': 'Client changed for {count} entries',
    'entries.client_changed.one': 'Client changed for 1 entry',
    'entries.activity_changed': 'Activity changed for {count} entries',
    'entries.activity_changed.one': 'Activity changed for 1 entry',

    'entries.select_group': 'Select everything in this group',
    'entries.mark_group_paid': 'Whole group paid',
    'entries.mark_group_open': 'Whole group outstanding',
    'entries.mark_group_non_billable': 'Whole group non-billable',
    'entries.set_budget': 'Set budget…',
    'entries.edit_budget': 'Change budget…',
    'entries.budget': 'Budget (quoted price)',
    'entries.budget_title': 'Budget',
    'entries.budget_hint': 'Leave empty to remove the budget.',
    'entries.budget_saved': 'Budget saved',
    'entries.budget_vs': '{actual} of {budget}',
    'entries.budget_left': '{amount} left',
    'entries.budget_over': '{amount} over budget',

    'entries.continue_timer': 'Continue in timer',
    'entries.timer_started': 'Timer started',
    'entries.replace_timer_title': 'Replace the current timer?',
    'entries.replace_timer_message': 'A timer is already running. If you continue, a new timer starts with this client, activity and description.',
    'entries.register_payment': 'Record payment…',
    'entries.delete_one_title': 'Delete entry?',
    'entries.delete_one_message': 'You can undo this right after.',
    'entries.deleted_one': 'Entry deleted',
    'entries.restored': 'Restored',

    'entries.new_title': 'New entry',
    'entries.edit_title': 'Edit entry',
    'entries.duplicate_title': 'Duplicate entry',
    'entries.duplicate_of': 'Copy of {date}',
    'entries.section_time': 'Time',
    'entries.section_what': 'Work',
    'entries.section_money': 'Billing',
    'entries.section_payment': 'Payment',
    'entries.now': 'Now',
    'entries.min': 'min',
    'entries.rounded_from': 'Rounded from {original} ({diff} min)',
    'entries.rounding_rule': 'Rounding: {mode} to {inc} min',
    'entries.rounding_applied': 'Rounding applied: {mode}, {inc} min',
    'entries.rounding_none': 'none',
    'entries.rounding_nearest': 'nearest',
    'entries.rounding_up': 'up',
    'entries.rounding_down': 'down',
    'entries.rounding_threshold': 'threshold',
    'entries.overnight_split': 'Runs past midnight: saved as two entries (until 23:59, and from 00:00 on {date}).',
    'entries.client_placeholder': 'Choose or type a client',
    'entries.activity_placeholder': 'Choose or type an activity',
    'entries.description_placeholder': 'What did you work on?',
    'entries.create_client': 'Add "{name}" as a new client',
    'entries.create_activity': 'Add "{name}" as an activity',
    'entries.client_created': 'Client {name} added',
    'entries.no_activities': 'No activities yet: type a name to add one',
    'entries.billable_hint': 'Counts towards revenue and outstanding amounts.',
    'entries.amount_paid': 'Amount paid',
    'entries.outstanding_label': 'Outstanding',
    'entries.mark_fully_paid': 'Fully paid',
    'entries.invoice_reference': 'Invoice number',
    'entries.invoice_hint': 'Up to 50 characters.',
    'entries.add': 'Add',
    'entries.created': 'Entry added',
    'entries.created_split': 'Saved as two entries',
    'entries.updated': 'Entry updated',
    'entries.discard_title': 'Discard changes?',
    'entries.discard_message': 'You have changes that have not been saved.',
    'entries.discard': 'Discard',
    'entries.err_date': 'Choose a date',
    'entries.err_time': 'Enter a time',
    'entries.err_zero': 'Start and end are the same',
    'entries.err_end_after_start': 'The end time must be after the start time',
    'entries.err_pause': 'Break cannot be negative',
    'entries.err_pause_long': 'Break is longer than the time worked',
    'entries.err_client': 'Choose a client',
    'entries.err_rate': 'Rate cannot be negative',
    'entries.err_paid_max': 'Cannot be more than {max}',
    'entries.err_amount': 'Enter a valid amount',
    'entries.err_invoice': 'Up to 50 characters',

    'entries.payment_title': 'Record payment',
    'entries.payment_mode': 'Mode',
    'entries.payment_add': 'Add amount',
    'entries.payment_replace': 'Replace total',
    'entries.payment_amount_add': 'Amount received',
    'entries.payment_amount_total': 'Total paid',
    'entries.payment_new_total': 'New total paid: {amount}',
    'entries.status_auto': 'Set automatically from the amount',
    'entries.payment_save': 'Save payment',
    'entries.payment_saved': 'Payment saved',
    'entries.partial_title': 'Partial payment',
    'entries.partial_desc': '{count} entries, {amount} outstanding in total',
    'entries.partial_desc.one': '1 entry, {amount} outstanding',
    'entries.partial_mode': 'Distribution',
    'entries.partial_proportional': 'Proportional',
    'entries.partial_sequential': 'Oldest first',
    'entries.partial_proportional_hint': 'The amount is split in proportion to what is outstanding per entry.',
    'entries.partial_sequential_hint': 'The oldest entries are paid in full first.',
    'entries.payment_applied': '{amount} spread over {count} entries',
    'entries.payment_applied.one': '{amount} booked on 1 entry',

    'export.title': 'Export',
    'export.selection_desc': '{count} selected entries',
    'export.selection_desc.one': '1 selected entry',
    'export.what': 'What',
    'export.format': 'Format',
    'export.columns': 'Columns',
    'export.filter': 'Period and clients',
    'export.type_detailed': 'Detailed',
    'export.type_detailed_hint': 'Every entry on its own line',
    'export.type_per_client': 'Per client',
    'export.type_per_client_hint': 'Hours and amounts per client',
    'export.type_per_activity': 'Per activity',
    'export.type_per_activity_hint': 'With the budget per activity',
    'export.type_per_day': 'Per day',
    'export.type_per_day_hint': 'Daily totals, handy for timesheets',
    'export.opt_description': 'Description',
    'export.opt_financial': 'Financial columns',
    'export.opt_times': 'Start, end and break',
    'export.from': 'From',
    'export.to': 'Until',
    'export.preset_month': 'This month',
    'export.preset_last_month': 'Last month',
    'export.preset_year': 'This year',
    'export.all_available': 'All',
    'export.run': 'Export {format}',
    'export.done': '{count} entries exported',
    'export.done.one': '1 entry exported',
    'export.nothing': 'No entries to export',
    'export.summary_count': '{count} entries',
    'export.summary_count.one': '1 entry',
    'export.hours_unit': 'hours',
    'export.default_title': 'Timesheet',
    'export.filename_base': 'entries',
    'export.sheet_entries': 'Entries',
    'export.col_pause': 'Break (min)',
    'export.col_paid': 'Paid',
    'export.col_invoice': 'Invoice',
    'export.col_count': 'Count',
    'export.col_revenue': 'Revenue',
    'export.col_outstanding': 'Outstanding',
    'export.col_budget': 'Budget',
    'export.generated_on': 'Created on {date} with Timepeak',
    'export.page_of': 'Page {page} of {total}'
  }
});
